module.exports = __webpack_public_path__ + "static/apoyo03-18970591aa51080a0ea95523753d1889.jpg";